document.addEventListener('click', function(e){
  const link = e.target.closest('a, button');
  if(!link) return;
  const r = document.createElement('span');
  r.className = 'ripple';
  r.style.left = e.clientX + 'px';
  r.style.top = e.clientY + 'px';
  document.body.appendChild(r);
  setTimeout(()=>r.remove(), 600);
});

document.addEventListener('submit', async function(e){
  const form = e.target.closest('form[data-ajax-cart]');
  if(!form) return;
  e.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const old = button ? button.textContent : '';
  if(button){button.textContent='Adding...'; button.disabled=true;}
  try{
    const res = await fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}});
    if(!res.ok) throw new Error('Cart add failed');
    if(button) button.textContent='Added ✦';
    setTimeout(()=>{ window.location.href='/cart'; }, 450);
  }catch(err){
    form.submit();
  }finally{
    setTimeout(()=>{ if(button){button.textContent=old; button.disabled=false;} }, 1000);
  }
});
